import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "16",
  fill: "none",
  viewBox: "0 0 12 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--color-gray-07)",
      d: "m1.218 6.566 4.558-4.558 4.558 4.558a.625.625 0 0 0 .884-.883l-5-5a.625.625 0 0 0-.884 0l-5 5a.625.625 0 0 0 .884.883M10.334 9.433 5.776 13.99 1.218 9.433a.625.625 0 0 0-.884.883l5 5c.244.244.64.244.884 0l5-5a.625.625 0 0 0-.884-.883"
    }, null, -1)
  ]))]))
}
export default { render: render }